<template>
  <div
    v-if="
      ($store.state.fastPermissoes.administrador == 'S' || $store.state.fastPermissoes.tesouraria == 'S') &&
        $store.state.fastPermissoes.ativo == 'S' &&
        $store.state.fastPlataformaModulos.modulo_secretaria
    "
  >
    <div class="fd-app-wrap">
      <div class="container">
        <!-- breadcrumb -->
        <nav>
          <ul class="fd-app-breadcrumb">
            <li class="fd-app-breadcrumb-item">
              <a
                href="/minhas-plataformas"
                class="aluno_font_color"
                @click.prevent="$router.push('/minhas-plataformas')"
              >Minhas Plataformas</a>
            </li>
            <li class="fd-app-breadcrumb-item">
              <a
                class="aluno_font_color"
                href="#"
                @click.prevent="$router.push('/plataforma/' + $route.params.id_plataforma)"
              >Plataforma {{ $store.state.fastPlataforma.nome_plataforma }}</a>
            </li>
            <li class="fd-app-breadcrumb-item active">
              <a
                class="aluno_font_color"
                href="#"
              >Tesouraria</a>
            </li>
          </ul>
        </nav>

        <!-- /breadcrumb -->
      </div>
      <div class="fd-mode-adm-content mt-4">
        <div class="container">
          <div class="row">
            <div
              id="body_conteudo_modo_admin"
              class="col-sm-12 col-md-12 fd-mode-adm-content-body col-lg-12 ml-0"
            >
              <!-- fd-app-welcome -->
              <section class="fd-app-welcome text-left">
                <h1 class="aluno_font_color">
                  Tesouraria
                  <span>Virtual</span>
                </h1>

                <img :src="require('@/assets/images/form-effect-01.png')">
              </section>
              <!-- /fd-app-welcome -->
              <div class="row">
                <div class="col-12">
                  <section class="fd-mode-opcoes">
                    <!-- Dashboard -->
                    <div 
                      class="fd-mode-opcoes-item position-relative"
                      data-toggle="collapse"
                      href="#collapseBoxPersonalizar"
                      role="button"
                      aria-expanded="false"
                      aria-controls="collapseBoxPersonalizar"
                      dont-toogle-lg
                    >
                      <div class="row align-items-center">
                        <a        
                          :href="'/plataforma/' + $route.params.id_plataforma + '/tesouraria/dashboard'"
                          class="col-sm-12 col-md-12 col-lg-8"                 
                          :style="{
                            backgroundColor: $store.state.fastPersonalizacao
                              .menu_background_color
                              ? $store.state.fastPersonalizacao
                                .menu_background_color
                              : '#fff',
                          }"
                          @click.prevent="$router.push('/plataforma/' + $route.params.id_plataforma + '/tesouraria/dashboard')"
                        >
                          <div
                            class="col-sm-12 col-md-12 col-lg-12 fd-mode-opcoes-item-content con-classroom-anotacoes-desativado shadow rounded"
                          >
                            <img
                              :src="require('@/assets/images/app/matriz-icon.png')"
                              class="img-fluid mr-2"
                              style="max-width: 115px"
                            >
                            <h3 class="menu_font_color">Dashboard financeiro</h3>
                          </div>
                        </a>
                      </div>
                    </div>
                    <!-- Configurar -->
                    <div                      
                      class="fd-mode-opcoes-item position-relative"
                      data-toggle="collapse"
                      href="#collapseBoxPersonalizar"
                      role="button"
                      aria-expanded="false"
                      aria-controls="collapseBoxPersonalizar"
                      dont-toogle-lg
                    >
                      <div class="row align-items-center">
                        <a                          
                          class="col-sm-12 col-md-12 col-lg-8"
                          :style="{
                            backgroundColor: $store.state.fastPersonalizacao
                              .menu_background_color
                              ? $store.state.fastPersonalizacao
                                .menu_background_color
                              : '#fff',
                          }"
                        >
                          <div
                            class="col-sm-12 col-md-12 col-lg-12 fd-mode-opcoes-item-content con-classroom-anotacoes-desativado shadow rounded-top"
                          >
                            <img
                              :src="require('@/assets/images/app/personalizar-icon.png')"
                              class="img-fluid"
                            >
                            <h3 class="menu_font_color">Configurar</h3>
                          </div>
                        </a>
                        <div class="col-sm-12 col-md-12 col-lg-8">
                          <b-navbar
                            toggleable="sm"
                            type="dark"
                            variant="secondary"
                            class="rounded-bottom"
                          >
                            <b-navbar-toggle target="nav-collapse" />

                            <b-collapse
                              id="nav-collapse"
                              is-nav
                            >
                              <b-navbar-nav
                                class="ml-auto"
                                fill
                              >                                
                                
                                <b-nav-item
                                  href="#"
                                  @click.prevent="$router.push('/plataforma/' + $route.params.id_plataforma + '/secretaria/planos?tesouraria')"
                                >
                                  <span class="text-white"><b-icon-credit-card /> Pagamentos</span>                                  
                                </b-nav-item>
                                <b-nav-item
                                  href="#"
                                  @click.prevent="$router.push('/plataforma/' + $route.params.id_plataforma + '/tesouraria/itens-cobranca')"
                                >
                                  <span class="text-white"><b-icon-bag-check /> Itens de cobrança</span>                                  
                                </b-nav-item>
                                <b-nav-item
                                  href="#"
                                  @click.prevent="$router.push('/plataforma/' + $route.params.id_plataforma + '/tesouraria/comissoes')"
                                >
                                  <span class="text-white"><b-icon-award-fill /> Comissões</span>                                  
                                </b-nav-item>
                                <b-nav-item-dropdown right>
                                  <template #button-content>
                                    <span class="text-white"><b-icon-people-fill /> Pessoas</span>  
                                  </template>
                                  <b-dropdown-item
                                    href="#"
                                    @click.prevent="$router.push('/plataforma/' + $route.params.id_plataforma + '/tesouraria/pessoas')"
                                  >
                                    Cadastro
                                  </b-dropdown-item>                              
                                  <b-dropdown-item
                                    href="#"
                                    @click.prevent="$router.push('/plataforma/' + $route.params.id_plataforma + '/tesouraria/funcoes')"
                                  >
                                    Funções
                                  </b-dropdown-item>    
                                </b-nav-item-dropdown>
                                <b-nav-item-dropdown right>
                                  <template #button-content>
                                    <span class="text-white"><b-icon-file-earmark-text /> Documentos</span>
                                  </template>
                                  <b-dropdown-item
                                    href="#"
                                    @click.prevent="$router.push('/plataforma/' + $route.params.id_plataforma + '/secretaria/contratos?tesouraria')"
                                  >
                                    Templates de contrato
                                  </b-dropdown-item>                              
                                  <b-dropdown-item
                                    href="#"
                                    @click.prevent="$router.push('/plataforma/' + $route.params.id_plataforma + '/secretaria/documentos?tesouraria')"
                                  >
                                    Tipos de documento
                                  </b-dropdown-item>    
                                </b-nav-item-dropdown>
                              </b-navbar-nav>
                            </b-collapse>
                          </b-navbar>
                        </div>
                      </div>
                    </div>
                     <!-- Fiscal -->
                    <div                      
                      class="fd-mode-opcoes-item position-relative d-none"
                      data-toggle="collapse"
                      href="#collapseBoxPersonalizar"
                      role="button"
                      aria-expanded="false"
                      aria-controls="collapseBoxPersonalizar"
                      dont-toogle-lg
                    >
                      <div class="row align-items-center">
                        <a                          
                          class="col-sm-12 col-md-12 col-lg-8"
                          :style="{
                            backgroundColor: $store.state.fastPersonalizacao
                              .menu_background_color
                              ? $store.state.fastPersonalizacao
                                .menu_background_color
                              : '#fff',
                          }"
                        >
                          <div
                            class="col-sm-12 col-md-12 col-lg-12 fd-mode-opcoes-item-content con-classroom-anotacoes-desativado shadow rounded-top"
                          >
                            <img
                              :src="require('@/assets/images/app/responsive.png')"
                              class="img-fluid mr-2"
                              style="max-width: 115px"
                            >
                            <h3 class="menu_font_color">Fiscal</h3>
                          </div>
                        </a>
                        <div class="col-sm-12 col-md-12 col-lg-8">
                          <b-navbar
                            toggleable="sm"
                            type="dark"
                            variant="secondary"
                            class="rounded-bottom"
                          >
                            <b-navbar-toggle target="nav-collapse" />

                            <b-collapse
                              id="nav-collapse"
                              is-nav
                            >
                              <b-navbar-nav
                                class="ml-auto"
                                fill
                              >                                
                                
                                <b-nav-item
                                  href="#"
                                  @click.prevent="$router.push('/plataforma/' + $route.params.id_plataforma + '/tesouraria/cadastro-empresa')"
                                >
                                  <span class="text-white"><b-icon-building /> Cadastro Empresa</span>                                  
                                </b-nav-item>
                                <b-nav-item
                                  href="#"
                                  @click.prevent="$router.push('/plataforma/' + $route.params.id_plataforma + '/tesouraria/notas-fiscais')"
                                >
                                  <span class="text-white"><b-icon-file-earmark-spreadsheet /> Notas Fiscais</span>                                  
                                </b-nav-item>
                                
                              </b-navbar-nav>
                            </b-collapse>
                          </b-navbar>
                        </div>
                      </div>
                    </div>           
                    <!-- Gestão de recebíveis -->
                    <div 
                      class="fd-mode-opcoes-item position-relative"
                      data-toggle="collapse"
                      href="#collapseBoxPersonalizar"
                      role="button"
                      aria-expanded="false"
                      aria-controls="collapseBoxPersonalizar"
                      dont-toogle-lg
                    >
                      <div class="row align-items-center">
                        <a       
                          :href="'/plataforma/' + $route.params.id_plataforma + '/tesouraria/emissao-boletos'"
                          class="col-sm-12 col-md-12 col-lg-8"                   
                          :style="{
                            backgroundColor: $store.state.fastPersonalizacao
                              .menu_background_color
                              ? $store.state.fastPersonalizacao
                                .menu_background_color
                              : '#fff',
                          }"
                          @click.prevent="$router.push('/plataforma/' + $route.params.id_plataforma + '/tesouraria/emissao-boletos')"
                        >
                          <div
                            class="col-sm-12 col-md-12 col-lg-12 fd-mode-opcoes-item-content con-classroom-anotacoes-desativado shadow rounded"
                          >
                            <img
                              :src="require('@/assets/images/app/receipt.png')"
                              class="img-fluid mr-2"
                              style="max-width: 115px"
                            >
                            <h3 class="menu_font_color">Gestão de recebíveis</h3>
                          </div>                          
                        </a>
                        <div class="col-sm-12 col-md-12 col-lg-8">
                          <b-navbar
                            toggleable="sm"
                            type="dark"
                            variant="secondary"
                            class="rounded-bottom d-none"
                          >
                            <b-navbar-toggle target="nav-collapse" />

                            <b-collapse
                              id="nav-collapse"
                              is-nav
                            >
                              <b-navbar-nav
                                class="ml-auto"
                                fill
                              >                                
                                
                                <b-nav-item
                                  href="#"
                                  @click.prevent="$router.push('/plataforma/' + $route.params.id_plataforma + '/tesouraria/posicao-contas-receber')"
                                >
                                  <span class="text-white"><b-icon-calendar2-week /> Posição contas a receber</span>                                 
                                </b-nav-item>
                                
                              </b-navbar-nav>
                            </b-collapse>
                          </b-navbar>
                        </div>
                      </div>
                    </div>
                    <!-- Comissões -->
                    <div 
                      class="fd-mode-opcoes-item position-relative"
                      data-toggle="collapse"
                      href="#collapseBoxPersonalizar"
                      role="button"
                      aria-expanded="false"
                      aria-controls="collapseBoxPersonalizar"
                      dont-toogle-lg
                    >
                      <div class="row align-items-center">
                        <a                          
                          class="col-sm-12 col-md-12 col-lg-8"
                          :style="{
                            backgroundColor: $store.state.fastPersonalizacao
                              .menu_background_color
                              ? $store.state.fastPersonalizacao
                                .menu_background_color
                              : '#fff',
                          }"
                          :href="'/plataforma/' + $route.params.id_plataforma + '/tesouraria/gestao-comissoes'"
                          @click.prevent="$router.push('/plataforma/' + $route.params.id_plataforma + '/tesouraria/gestao-comissoes')"
                        >
                          <div
                            class="col-sm-12 col-md-12 col-lg-12 fd-mode-opcoes-item-content con-classroom-anotacoes-desativado shadow rounded"
                          >
                            <img
                              :src="require('@/assets/images/app/gateway.png')"
                              class="img-fluid"
                              style="max-width: 115px"
                            >
                            <h3 class="menu_font_color">Comissões</h3>
                          </div>
                        </a>
                      </div>
                    </div>
                    <!-- <div 
                      class="fd-mode-opcoes-item position-relative"
                      data-toggle="collapse"
                      href="#collapseBoxPersonalizar"
                      role="button"
                      aria-expanded="false"
                      aria-controls="collapseBoxPersonalizar"
                      dont-toogle-lg
                    >
                      <div class="row align-items-center">
                        <a                          
                          class="col-sm-12 col-md-12 col-lg-8"
                          :style="{
                            backgroundColor: $store.state.fastPersonalizacao
                              .menu_background_color
                              ? $store.state.fastPersonalizacao
                                .menu_background_color
                              : '#fff',
                          }"
                          :href="'/plataforma/' + $route.params.id_plataforma + '/tesouraria/geracaocobrancas'"
                          @click.prevent="$router.push('/plataforma/' + $route.params.id_plataforma + '/tesouraria/geracaocobrancas')"
                        >
                          <div
                            class="col-sm-12 col-md-12 col-lg-12 fd-mode-opcoes-item-content con-classroom-anotacoes-desativado shadow rounded"
                          >
                            <img
                              :src="require('@/assets/images/app/shoppingbasket.png')"
                              class="img-fluid"
                              style="max-width: 115px"
                            >
                            <h3 class="menu_font_color">Geração de cobranças</h3>
                          </div>
                        </a>
                      </div>
                    </div> -->
                    <!-- Console GERENCIANET -->
                    <div 
                      class="fd-mode-opcoes-item position-relative d-none"
                      data-toggle="collapse"
                      href="#collapseBoxPersonalizar"
                      role="button"
                      aria-expanded="false"
                      aria-controls="collapseBoxPersonalizar"
                      dont-toogle-lg
                    >
                      <div class="row align-items-center">
                        <a                          
                          class="col-sm-12 col-md-12 col-lg-8"
                          :style="{
                            backgroundColor: $store.state.fastPersonalizacao
                              .menu_background_color
                              ? $store.state.fastPersonalizacao
                                .menu_background_color
                              : '#fff',
                          }"
                          :href="'/plataforma/' + $route.params.id_plataforma + '/tesouraria/gerencianet'"
                          @click.prevent="$router.push('/plataforma/' + $route.params.id_plataforma + '/tesouraria/gerencianet')"
                        >
                          <div
                            class="col-sm-12 col-md-12 col-lg-12 fd-mode-opcoes-item-content con-classroom-anotacoes-desativado shadow rounded"
                          >
                            <img
                              :src="require('@/assets/images/app/gateway.png')"
                              class="img-fluid"
                              style="max-width: 115px"
                            >
                            <h3 class="menu_font_color">Console GERENCIANET</h3>
                          </div>
                        </a>
                      </div>
                    </div>
                    <!-- Fluxo de caixa -->
                    <div 
                      class="fd-mode-opcoes-item position-relative d-none"
                      data-toggle="collapse"
                      href="#collapseBoxPersonalizar"
                      role="button"
                      aria-expanded="false"
                      aria-controls="collapseBoxPersonalizar"
                      dont-toogle-lg
                    >
                      <div class="row align-items-center">
                        <a                          
                          class="col-sm-12 col-md-12 col-lg-8"
                          :style="{
                            backgroundColor: $store.state.fastPersonalizacao
                              .menu_background_color
                              ? $store.state.fastPersonalizacao
                                .menu_background_color
                              : '#fff',
                          }"
                          :href="'/plataforma/' + $route.params.id_plataforma + '/tesouraria/fluxo-caixa'"
                          @click.prevent="$router.push('/plataforma/' + $route.params.id_plataforma + '/tesouraria/fluxo-caixa')"
                        >
                          <div
                            class="col-sm-12 col-md-12 col-lg-12 fd-mode-opcoes-item-content con-classroom-anotacoes-desativado shadow rounded"
                          >
                            <img
                              :src="require('@/assets/images/app/money-flow.png')"
                              class="img-fluid"
                              style="max-width: 115px"
                            >
                            <h3 class="menu_font_color">Fluxo de caixa</h3>
                          </div>
                        </a>
                      </div>
                    </div>
                    <!-- Renegociação -->
                    <div 
                      class="fd-mode-opcoes-item position-relative d-none"
                      data-toggle="collapse"
                      href="#collapseBoxPersonalizar"
                      role="button"
                      aria-expanded="false"
                      aria-controls="collapseBoxPersonalizar"
                      dont-toogle-lg
                    >
                      <div class="row align-items-center">
                        <a                          
                          class="col-sm-12 col-md-12 col-lg-8"
                          :style="{
                            backgroundColor: $store.state.fastPersonalizacao
                              .menu_background_color
                              ? $store.state.fastPersonalizacao
                                .menu_background_color
                              : '#fff',
                          }"
                          :href="'/plataforma/' + $route.params.id_plataforma + '/tesouraria/renegociacao'"
                          @click.prevent="$router.push('/plataforma/' + $route.params.id_plataforma + '/tesouraria/renegociacao')"
                        >
                          <div
                            class="col-sm-12 col-md-12 col-lg-12 fd-mode-opcoes-item-content con-classroom-anotacoes-desativado shadow rounded"
                          >
                            <img
                              :src="require('@/assets/images/app/talk.png')"
                              class="img-fluid"
                              style="max-width: 115px"
                            >
                            <h3 class="menu_font_color">Renegociação</h3>
                          </div>
                        </a>
                      </div>
                    </div>
                    <!-- Controle de contas -->
                    <div 
                      class="fd-mode-opcoes-item position-relative d-none"
                      data-toggle="collapse"
                      href="#collapseBoxPersonalizar"
                      role="button"
                      aria-expanded="false"
                      aria-controls="collapseBoxPersonalizar"
                      dont-toogle-lg
                    >
                      <div class="row align-items-center">
                        <a                          
                          class="col-sm-12 col-md-12 col-lg-8"
                          :style="{
                            backgroundColor: $store.state.fastPersonalizacao
                              .menu_background_color
                              ? $store.state.fastPersonalizacao
                                .menu_background_color
                              : '#fff',
                          }"
                          :href="'/plataforma/' + $route.params.id_plataforma + '/tesouraria/controle-contas'"
                          @click.prevent="$router.push('/plataforma/' + $route.params.id_plataforma + '/tesouraria/controle-contas')"
                        >
                          <div
                            class="col-sm-12 col-md-12 col-lg-12 fd-mode-opcoes-item-content con-classroom-anotacoes-desativado shadow rounded"
                          >
                            <img
                              :src="require('@/assets/images/app/accountant.png')"
                              class="img-fluid"
                              style="max-width: 115px"
                            >
                            <h3 class="menu_font_color">Controle de contas</h3>
                          </div>
                        </a>
                      </div>
                    </div>
                    <!-- Gestão de recebíveis -->
                    <div 
                      class="fd-mode-opcoes-item position-relative d-none"
                      data-toggle="collapse"
                      href="#collapseBoxPersonalizar"
                      role="button"
                      aria-expanded="false"
                      aria-controls="collapseBoxPersonalizar"
                      dont-toogle-lg
                    >
                      <div class="row align-items-center">
                        <a                          
                          class="col-sm-12 col-md-12 col-lg-8"
                          :style="{
                            backgroundColor: $store.state.fastPersonalizacao
                              .menu_background_color
                              ? $store.state.fastPersonalizacao
                                .menu_background_color
                              : '#fff',
                          }"
                          :href="'/plataforma/' + $route.params.id_plataforma + '/tesouraria/gestao-recebiveis'"
                          @click.prevent="$router.push('/plataforma/' + $route.params.id_plataforma + '/tesouraria/gestao-recebiveis')"
                        >
                          <div
                            class="col-sm-12 col-md-12 col-lg-12 fd-mode-opcoes-item-content con-classroom-anotacoes-desativado shadow rounded"
                          >
                            <img
                              :src="require('@/assets/images/app/receive.png')"
                              class="img-fluid"
                              style="max-width: 115px"
                            >
                            <h3 class="menu_font_color">Contas a Receber</h3>
                          </div>
                        </a>
                      </div>
                    </div>
                    <div 
                      class="fd-mode-opcoes-item position-relative d-none"
                      data-toggle="collapse"
                      href="#collapseBoxPersonalizar"
                      role="button"
                      aria-expanded="false"
                      aria-controls="collapseBoxPersonalizar"
                      dont-toogle-lg
                    >
                      <div class="row align-items-center">
                        <a                          
                          class="col-sm-12 col-md-12 col-lg-8"
                          :style="{
                            backgroundColor: $store.state.fastPersonalizacao
                              .menu_background_color
                              ? $store.state.fastPersonalizacao
                                .menu_background_color
                              : '#fff',
                          }"
                          :href="'/plataforma/' + $route.params.id_plataforma + '/tesouraria/contas-pagar'"
                          @click.prevent="$router.push('/plataforma/' + $route.params.id_plataforma + '/tesouraria/contas-pagar')"
                        >
                          <div
                            class="col-sm-12 col-md-12 col-lg-12 fd-mode-opcoes-item-content con-classroom-anotacoes-desativado shadow rounded"
                          >
                            <img
                              :src="require('@/assets/images/app/credit-card.png')"
                              class="img-fluid"
                              style="max-width: 115px"
                            >
                            <h3 class="menu_font_color">Contas a pagar</h3>
                          </div>
                        </a>
                      </div>
                    </div>
                    <!-- Relatórios -->
                    <div                      
                      class="fd-mode-opcoes-item position-relative"
                      data-toggle="collapse"
                      href="#collapseBoxPersonalizar"
                      role="button"
                      aria-expanded="false"
                      aria-controls="collapseBoxPersonalizar"
                      dont-toogle-lg
                    >
                      <div class="row align-items-center">
                        <a                          
                          class="col-sm-12 col-md-12 col-lg-8"
                          :style="{
                            backgroundColor: $store.state.fastPersonalizacao
                              .menu_background_color
                              ? $store.state.fastPersonalizacao
                                .menu_background_color
                              : '#fff',
                          }"
                        >
                          <div
                            class="col-sm-12 col-md-12 col-lg-12 fd-mode-opcoes-item-content con-classroom-anotacoes-desativado shadow rounded-top"
                          >
                            <img
                              :src="require('@/assets/images/app/responsive.png')"
                              class="img-fluid mr-2"
                              style="max-width: 115px"
                            >
                            <h3 class="menu_font_color">Relatórios</h3>
                          </div>
                        </a>
                        <div class="col-sm-12 col-md-12 col-lg-8">
                          <b-navbar
                            toggleable="sm"
                            type="dark"
                            variant="secondary"
                            class="rounded-bottom"
                          >
                            <b-navbar-toggle target="nav-collapse" />

                            <b-collapse
                              id="nav-collapse"
                              is-nav
                            >
                              <b-navbar-nav
                                class="ml-auto"
                                fill
                              >                                

                                <b-nav-item
                                  href="#"
                                >
                                  <b-nav-item-dropdown right>
                                  <template #button-content>
                                    <span class="text-white"><b-icon-kanban /> Contas a Receber</span>  
                                  </template>
                                    <b-dropdown-item
                                      href="#"
                                      @click.prevent="$router.push('/plataforma/' + $route.params.id_plataforma + '/tesouraria/relatorios-contas-receber')"
                                    >
                                      Contas a Receber
                                    </b-dropdown-item>                              
                                    <b-dropdown-item
                                      href="#"
                                      @click.prevent="$router.push('/plataforma/' + $route.params.id_plataforma + '/tesouraria/relatorios-matriculas')"
                                    >
                                      Matrículas
                                    </b-dropdown-item>    
                                    <b-dropdown-item
                                      href="#"
                                      @click.prevent="$router.push('/plataforma/' + $route.params.id_plataforma + '/tesouraria/relatorios-aluno-posicao')"
                                    >
                                      Aluno Posição
                                    </b-dropdown-item> 
                                    <b-dropdown-item
                                      href="#"
                                      @click.prevent="$router.push('/plataforma/' + $route.params.id_plataforma + '/tesouraria/relatorios-cobranca-whatsapp')"
                                    >
                                      Cobrança (Whatsapp)
                                    </b-dropdown-item> 
                                    <!-- <b-dropdown-item
                                      href="#"
                                      @click.prevent="$router.push('/plataforma/' + $route.params.id_plataforma + '/tesouraria/relatorios-registro-inadimplencia')"
                                    >
                                      Registro Inadimplência
                                    </b-dropdown-item>  -->
                                  </b-nav-item-dropdown>                               
                                </b-nav-item>

                                <b-nav-item
                                  href="#"
                                  class="pt-1"
                                  @click.prevent="$router.push('/plataforma/' + $route.params.id_plataforma + '/tesouraria/relatorios-contratos-alunos')"
                                >
                                  <span class="text-white"><b-icon-building /> Contratos de alunos</span>                                  
                                </b-nav-item>
                                                                
                              </b-navbar-nav>
                            </b-collapse>
                          </b-navbar>
                        </div>
                      </div>
                    </div>   
                  </section>
                </div>
              </div>
              <!-- fd-app-meus-cursos -->
              <div class="mt-5 mb-5">
                <a
                  id="btn_voltar_modo_admin"
                  class="btn btn-red-hollow"
                  :href="
                    '/plataforma/' + $route.params.id_plataforma 
                  "
                  @click.prevent="$router.push('/plataforma/' + $route.params.id_plataforma)"
                >
                  <b-icon-arrow-return-left />
                  Voltar
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Modals -->

    <notifications
      group="foo"
      :close-on-click="false"
      position="bottom right"
    />
  </div>
</template>

<script>
import { settings } from "@/config";
import methods from "@/methods";

export default {
  name: "HomeInternoTesouraria",
  mixins: [methods],
  data: function () {
    return {
      modalWidthSm: this.isMobile() ? "80%" : "30%",
      modalWidthMd: this.isMobile() ? "90%" : "50%",
      modalWidthLg: this.isMobile() ? "100%" : "90%",
    };
  },
  mounted: function () {
    if (this.$route.params.id_plataforma) {
      this.getFastDependecias(this.$route.params.id_plataforma, 'tesouraria')
        .then(() => {
          if (
            this.$store.state.fastPlataformaModulos.modulo_secretaria
          ) {
            this.$store.state.fastCarregando = false;
          } else {
            this.$store.state.fastCarregando = false;
            this.exibeToasty("Módulo não disponível para sua plataforma", "error");
          }
        })
        .catch((e) => {
          this.exibeToasty(e, "error");
          this.$store.state.fastCarregando = false;
        });
    }
  },
  methods: {},
};
</script>

<style scope>
.tabs-component {
  margin: 1em 0;
}

.tabs-component-tabs {
  border: solid 1px #ddd;
  border-radius: 6px;
  margin-bottom: 5px;
}

@media (min-width: 992px) {
  .tabs-component-tabs {
    border: 0;
    align-items: stretch;
    display: flex;
    justify-content: flex-start;
    margin-bottom: -1px;
  }
}

.tabs-component-tab {
  color: #999;
  font-size: 14px;
  font-weight: 600;
  margin-right: 0;
  list-style: none;
}

.tabs-component-tab:hover {
  color: #666;
}

.tabs-component-tab.is-active {
  color: #000;
}

.tabs-component-tab.is-disabled * {
  color: #cdcdcd;
  cursor: not-allowed !important;
}

@media (min-width: 992px) {
  .tabs-component-tab {
    background-color: #fff;
    border: solid 1px #ddd;
    border-radius: 3px 3px 0 0;
    margin-right: 0.5em;
    transform: translateY(0px);
    transition: transform 0.3s ease;
  }

  .tabs-component-tab.is-active {
    border-bottom: solid 1px #fff;
    z-index: 2;
    transform: translateY(0);
  }
}

.tabs-component-tab-a {
  align-items: center;
  color: inherit;
  display: flex;
  padding: 0.75em 1em;
  text-decoration: none;
}

.tabs-component-panels {
  padding: 4em 0;
}

@media (min-width: 992px) {
  .tabs-component-panels {
    border-top-left-radius: 0;
    background-color: #fff;
    border: solid 1px #ddd;
    border-radius: 0 6px 6px 6px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);
    padding: 2em;
  }
}
.prefix,
.suffix {
  align-items: center;
  border-radius: 1.25rem;
  display: flex;
  font-size: 0.75rem;
  flex-shrink: 0;
  height: 1.25rem;
  justify-content: center;
  line-height: 1.25rem;
  min-width: 1.25rem;
  padding: 0 0.1em;
}

.prefix {
  background-color: #d1e8eb;
  color: #0c5174;
  margin-right: 0.35em;
}

.suffix {
  background-color: #c03;
  color: #fff;
  margin-left: 0.35em;
}

@media (min-width: 992px) {
  .suffix {
    position: absolute;
    right: -0.6em;
    top: -0.725em;
  }
}
</style>
